// import { Input } from "antd";
// import Search from "antd/lib/input/Search";
import React from "react";
import { useAppState } from "src/contexts/AppContext";
//ene bol lCOmment test push
const Breadcrumb = () => {
  const { dispatch } = useAppState();
  return (
    <div className="breadcrumb-header justify-content-between">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active" aria-current="page">
            <h4 style={{ fontSize: 20, color: "white" }}>
              Танд энэ өдрийн мэнд хүргэе
            </h4>
          </li>
        </ol>
      </nav>

      <div
        className="d-flex my-auto"
        onClick={() => dispatch({ type: "CLICK_MENU", data: 0 })}
        style={{ cursor: "pointer" }}
      >
        <div className=" d-flex right-page">
          <div className="d-flex justify-content-center">
            <div className=""></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(Breadcrumb);
